module.exports = __webpack_public_path__ + "img/customer_medium.95d3ab63.webp";